import { render, staticRenderFns } from "./TaskStatus.yaml?vue&type=template&id=5196f62e&component"
import script from "./TaskStatus.yaml?vue&type=script&lang=ts&component"
export * from "./TaskStatus.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports